import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private themes: { [key: string]: { [key: string]: string } } = {
    anchor: {
      '--primary-color': '#103251',
      '--primary-text-color': 'white',
      '--secondary-color': '#6F94B0',
      '--secondary-text-color': 'white',
      '--logo-url': "url('assets/Hayrick/logo/anchor/logo-dark.svg')"
    },
    'anchor-stg': {
      '--primary-color': '#103251',
      '--primary-text-color': 'white',
      '--secondary-color': '#6F94B0',
      '--secondary-text-color': 'white',
      '--logo-url': "url('assets/Hayrick/logo/anchor/logo-dark.svg')"
    },
    e11even: {
      '--primary-color': 'red',
      '--primary-text-color': 'white',
      '--secondary-color': 'blue',
      '--secondary-text-color': 'white',
      '--logo-url': "url('assets/Hayrick/logo/e11even/logo-dark.svg')"
    },
    default: {
      '--primary-color': '#012c37',
      '--primary-text-color': 'white',
      '--secondary-color': '#f4a22a',
      '--secondary-text-color': 'white',
      '--logo-url': "url('assets/Hayrick/logo/default/logo-dark.svg')"
    }
  };

  applyTheme(client: string): void {
    const theme = this.themes[client] || this.themes['default'];
    Object.keys(theme).forEach(variable => {
      document.documentElement.style.setProperty(variable, theme[variable]);
    });
  }
}